import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  // lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/HighlightOff';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import { addGiftCard } from '../../actions/GiftCard';
import CancelButton from '../../components/atoms/CancelButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import FilesUpload from '../../components/molecules/FilesUpload';
import { sendLogin, uploadFile, resizeImageGiftCard } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    marginBottom: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column',
    height: '85%',
    overflowY: 'scroll'
  },
  image: {
    width: 'calc(25% - 10px)',
    '&:hover .delete': {
      display: 'block !important'
    },
    margin: 5,
    position: 'relative',
    border: '1px solid #ccc',
    padding: 5,
    borderRadius: 4,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(50% - 10px)'
    },
    [theme.breakpoints.up('md')]: {
      width: 'calc(50% - 10px)'
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(33.3333% - 10px)'
    },
    [theme.breakpoints.up('xl')]: {
      width: 'calc(25% - 10px)'
    }
  },
  delete: {
    // display: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    color: 'red'
  },
  previewImageWrap: {
    display: 'flex',
    WebkitFlexWrap: 'wrap',
    flexWrap: 'wrap'
  },
  topActions: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  selectCategories: {
    width: 200
  },
  menuPaper: {
    top: '190px !important'
  },
  cardWrap: {
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    () => {},
    dispatch => ({
      actions: bindActionCreators({ addGiftCard }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('imagesList', 'setImagesList', []),
  withState('imagesListPreview', 'setImagesListPreview', []),
  withState('categories', 'setCategories', []),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openProgress', 'updateOpenProgress', false),

  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
  // lifecycle({
  //   componentDidMount() {}
  // })
);

const Main = enhance(
  ({
    classes,
    listCategories,
    cancelAction,
    imagesList,
    setImagesList,
    setImagesListPreview,
    imagesListPreview,
    updateImagesList,
    categories,
    setCategories,
    updateOpenProgress,
    openProgress,
    loading,
    resultMessage,
    setResultMessage,
    updateLoading,
    actions
  }) => {
    const handleSetImagesList = values => {
      setImagesList([...values, ...imagesList]);
    };

    const handleSetImagesListPreview = values => {
      setImagesListPreview([...values, ...imagesListPreview]);
    };

    const setImageName = (value, index) => {
      const newImagesList = [...imagesList];
      newImagesList[index].imageName = value;
      setImagesList(newImagesList);
    };

    const deleteImage = index => {
      const newImagesList = [...imagesList];
      const newImagesListPreview = [...imagesListPreview];
      _.pullAt(newImagesList, [index]);
      _.pullAt(newImagesListPreview, [index]);
      setImagesList(newImagesList);
      setImagesListPreview(newImagesListPreview);
    };

    const registerAction = async () => {
      if (imagesList.length > 5) {
        alert(
          '最大5つの画像のみが許可されます。 アップロードする前に彼を削除してください'
        );
      } else if (!categories.length) {
        alert('カテゴリを選択してください');
      } else {
        updateLoading(true);
        updateOpenProgress(true);
        let giftCardImages = [];
        let giftCardCategories = [];
        if (imagesList.length > 0) {
          const imagePaths = await Promise.all(
            imagesList.map(async image => {
              if (image !== null) {
                let img = image;
                if (image.size > Number(process.env.REACT_APP_MAX_SIZE_ALLOW)) {
                  const { resizeImageFile } = await resizeImageGiftCard(image);
                  img = resizeImageFile;
                }
                const imagePath = await uploadFile(
                  'giftcard',
                  'images',
                  img,
                  'public'
                );
                return imagePath;
              }
              return null;
            })
          );
          giftCardImages = imagePaths
            .filter(i => i !== null)
            .map((i, index) => {
              return { image: i, imageName: imagesList[index].imageName };
            });
        }

        if (categories.length > 0) {
          giftCardCategories = _.reduce(
            categories,
            (res, catId) => {
              const cat = _.find(listCategories, ['giftCardCategoryId', catId]);
              if (cat) {
                res.push(cat);
              }
              return res;
            },
            []
          );
        }
        if (giftCardImages.length > 0 && giftCardCategories.length > 0) {
          const addGiftCardData = await actions.addGiftCard({
            giftCardCategories,
            giftCardImages
          });
          if (addGiftCardData.type === 'ADD_GIFTCARD_SUCCESS') {
            setResultMessage('画像アップロードに成功しました。');
            updateLoading(false);
            updateImagesList();
          } else {
            setResultMessage('画像アップロードに失敗しました。');
            updateLoading(false);
          }
        }
        cancelAction();
      }
    };

    const handleChangeCategories = event => {
      setCategories(event.target.value);
    };

    const renderValue = () => {
      const result = _.reduce(
        listCategories,
        (res, cat) => {
          if (_.includes(categories, cat.giftCardCategoryId)) {
            res.push(cat.giftCardCategoryName);
          }
          return res;
        },
        []
      );
      return result.join(', ');
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">ギフトカードを追加する</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.topActions}>
            <FormControl className={classes.formControl}>
              <InputLabel id="mutiple-checkbox-categories-label">
                カテゴリを選択
              </InputLabel>
              <Select
                labelId="mutiple-checkbox-categories-label"
                id="mutiple-checkbox-categories"
                multiple
                value={categories}
                onChange={handleChangeCategories}
                input={<Input />}
                renderValue={renderValue}
                MenuProps={{
                  classes: {
                    paper: classes.menuPaper
                  },
                  PaperProps: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                      width: 300
                    }
                  }
                }}
                className={classes.selectCategories}
              >
                {listCategories.map(cat => (
                  <MenuItem
                    key={cat.giftCardCategoryId}
                    value={cat.giftCardCategoryId}
                  >
                    <Checkbox
                      checked={categories.indexOf(cat.giftCardCategoryId) > -1}
                    />
                    <ListItemText primary={cat.giftCardCategoryName} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FilesUpload
              label="images"
              setFiles={handleSetImagesList}
              // previewImages={imagesListPreview}
              setPreviewImages={handleSetImagesListPreview}
            />
          </div>

          {imagesListPreview.length > 0 && (
            <div className={classes.previewImageWrap}>
              {imagesListPreview.map((previewImage, index) => (
                <div className={classes.image}>
                  <Card key={_.random(true)} className={classes.cardWrap}>
                    <CardActionArea>
                      <CardMedia component="img" image={previewImage} />
                    </CardActionArea>
                  </Card>
                  <TextField
                    // required
                    fullWidth
                    label="画像名"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setImageName(e.target.value, index);
                    }}
                    value={
                      imagesList[index].imageName
                        ? imagesList[index].imageName
                        : ''
                    }
                  />
                  <IconButton
                    color="inherit"
                    className={classNames('delete', classes.delete)}
                    //   style={{ display: 'none' }}
                    onClick={() => deleteImage(index)}
                  >
                    <DeleteIcon className={classes.menuIcons} />
                  </IconButton>
                </div>
              ))}
            </div>
          )}
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <RegisterButton
            onClickAction={registerAction}
            disabled={!imagesList.length}
          />
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
